import React, { useEffect, useState } from "react";
import { FiDownload } from "react-icons/fi";
import { useSelector } from "react-redux";
import { Catalogue } from "../../constants";
import { CATALOGUES } from "../../redux/serviceConstants";
import Breadcrumbs from "../Breadcrumbs/Breadcrumbs";
import { TbUpload } from "react-icons/tb";
import "./TopHeader.scss";
import { useNavigate } from "react-router-dom";
import Authorization from "../Authorization/Authorization";


function TopHeader({ nodes, triggerNavigation }) {
  const { catalogueId,releaseStatus } = useSelector((state) => state.router);
  const navigate=useNavigate();
  const [randomNumber, setRandomNumber] = useState(10000);

  function generateRandomNumber() {
    var num = Math.floor(Math.random() * 99999) + 10000;
    setRandomNumber(num);
  }
  function checkIfCataloguePage(ar) {
    let containsCatalogue = ar.filter((item) => item.label === Catalogue);
    return containsCatalogue?.length && ar.length === 2 ? true : false;
  }
  let UNMARKED_STATUS="not_marked";
  useEffect(() => {
    generateRandomNumber();
  }, []);

  return (
    <div className="top-header">
      <Breadcrumbs
        nodes={nodes}
        navigateFn={(node, idx, totalNodes) =>
          triggerNavigation(node, idx, totalNodes)
        }
      />
      {checkIfCataloguePage(nodes) && (
        <div>
         <a
          className="downloadbtn"
          href={`${window.location.origin}/mals/api/${CATALOGUES}/${catalogueId}/download?cache=${randomNumber}`}
          onClick={generateRandomNumber}
        >

          Download Catalogue{" "}
          <FiDownload style={{ marginLeft: "9px", minWidth: "10px" }} />
        </a>
        <Authorization>
         {
         releaseStatus === UNMARKED_STATUS && (
            <button className="downloadbtn refresh-bulk" onClick={()=>navigate(`/release/catalogue/${catalogueId}/bulkupload`)}>Refresh Data <TbUpload width={'20px'} style={{ marginLeft: "9px", minWidth: "10px" }}/></button>
          )
         }
        </Authorization>
        </div>

      )}
    </div>
  );
}

export default TopHeader;
